
import { useEffect, useState, useRef } from 'react';

export default function LocalCache() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const cachedItems = [
    'Case names/numbers',
    'Client names',
    'Opposing party/counsel',
  ];

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#0a0a0c]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <h2 className="text-white text-3xl sm:text-[42px] font-black text-center mb-16 sm:mb-20">
          Local Device Cache
        </h2>

        <div className="max-w-[800px] mx-auto space-y-8 sm:space-y-12">
          <p
            className={`text-[#d4d4d8] text-lg sm:text-xl text-center leading-relaxed transition-all duration-700 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Cached on your device only (never synced to us):
          </p>

          <div
            className={`p-6 sm:p-8 bg-[#0f0f11] border border-[#1a1a1c] rounded-xl transition-all duration-700 delay-200 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
            }`}
          >
            <div className="space-y-4">
              {cachedItems.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-[#06b6d4] text-lg sm:text-xl">✓</span>
                  <span className="text-white text-base sm:text-lg font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <p
            className={`text-[#a1a1aa] text-lg sm:text-xl text-center leading-relaxed transition-all duration-700 delay-400 ${
              animated ? 'opacity-100' : 'opacity-0'
            }`}
          >
            Clear anytime in Settings. Delete app = delete cache
          </p>
        </div>
      </div>
    </section>
  );
}
